import { render } from "./IconToastSuccess.vue?vue&type=template&id=2fe4b17e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__